module.exports = __webpack_public_path__ + "static/media/purecss-francine.ce3490cb.png";